import { render, staticRenderFns } from "./FormItem.vue?vue&type=template&id=f86387bc&scoped=true&"
import script from "./FormItem.vue?vue&type=script&lang=js&"
export * from "./FormItem.vue?vue&type=script&lang=js&"
import style0 from "./FormItem.vue?vue&type=style&index=0&id=f86387bc&scoped=true&lang=css&"
import style1 from "./FormItem.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f86387bc",
  null
  
)

export default component.exports